module.exports = __webpack_public_path__ + "static/media/CIER.93593fc4.jpg";